<template>
  <div class="mb-10">
    <HeaderBar :title="hTitle" />

  </div>
</template>

<script>
import HeaderBar from "../../../components/HeaderBar.vue";
export default {
  components: { HeaderBar },
  props: ["hTitle"],
};
</script>